import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import useStyles from "./SequenceDefaultTable.styles";
import SequenceList from "../SequenceList/SequenceList.component";
import CustomPagination from "../../Utilities/CustomPagination/CustomPagination.component";

const SequenceDefaultTable = ({
  sequenceList,
  dragScreen,
  handleDragScreen,
  setDragFileEnterModal,
  projectId,
  statusList,
  sliderState,
  toggler,
  updateRefreshCounter,
  setIsViewModalOpen,
  fetchFile,
  handleTableScroll,
  tableRef,
  scrollValue,
  currentPage,
  setIsNewPageLoading,
  handlePageChange,
  setViewMode,
  customFields,
}) => {
  const classes = useStyles();

  return (
    <TableContainer className={classes.sequenceTableContainer}>
      <Table aria-label="simple table" className={classes.table}>
        <TableHead className={classes.tableHeader}>
          <TableRow>
            <TableCell
              align="left"
              className={classes.sequencePageTableCellTwo}
            >
              Sequence Name
            </TableCell>
            <TableCell align="center" className={classes.sequencePageTableCell}>
              last Modified
            </TableCell>
            <TableCell align="center" className={classes.sequencePageTableCell}>
              Description
            </TableCell>
            <TableCell align="center" className={classes.sequencePageTableCell}>
              Status
            </TableCell>
            <TableCell align="center" className={classes.sequencePageTableCell}>
              Episode
            </TableCell>
            <TableCell align="center" className={classes.sequencePageTableCell}>
              Sequence Code
            </TableCell>
            <TableCell
              align="right"
              className={classes.sequencePageTableCellThree}
            >
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody
          className={classes.tableBody}
          onScroll={handleTableScroll}
          ref={tableRef}
          onLoad={() => {
            if (tableRef?.current && tableRef?.current?.scrollTop) {
              tableRef.current.scrollTop = scrollValue;
            }
          }}
          style={{
            height:
              sequenceList.count > 50
                ? `calc(100vh - 290px)`
                : `calc(100vh - 250px)`,
          }}
        >
          {sequenceList.results?.map((seq) => {
            return (
              <SequenceList
                key={seq.id}
                dragScreen={dragScreen}
                handleDragScreen={handleDragScreen}
                setDragFileEnterModal={setDragFileEnterModal}
                projectId={projectId}
                status={statusList}
                data={seq}
                sliderState={sliderState}
                toggler={toggler}
                updateRefreshCounter={updateRefreshCounter}
                setIsViewModalOpen={setIsViewModalOpen}
                fetchFile={fetchFile}
                setViewMode={setViewMode}
                customFields={customFields}
              />
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SequenceDefaultTable;
